var {AmpersandState, AmpersandCollection} = require('catalog/libs');

/**
 * filter breadcrumb model for each breadcrumb item
 */
var BreadcrumbItemModel = AmpersandState.extend({

    props: {
        id: 'string',
        facetValueId: 'string',
        parentId: 'string',
        label: 'string',
        context: 'string',
        count: 'string',
        isCategory: ['boolean', false, false]
    },

    derived: {
        labelValue: {
            deps: ['label'],
            fn: function() {
                return (this.count) ? this.label + ' (' + this.count + ')' : this.label;
            }
        },
        analyticsEvent: {
            deps: ['context'],
            fn: function() {
                return this.context + ' filter-track-click';
            }
        }
    }
});

/**
 * collection of filter breadcrumb models
 */
var FilterBreadcrumbCollection = AmpersandCollection.extend({

    model: BreadcrumbItemModel,
    comparator: function(a, b) {
        return b.isCategory - a.isCategory;
    }
});

/**
 * filter breadcrumb model
 */
var BreadcrumbModel = AmpersandState.extend({

    props: {
        hasCategories: ['boolean', false, false],
        pageLabel: 'string',
        childLabel: 'string'
    },

    collections: {
        items: FilterBreadcrumbCollection
    }

    //removed "category label", core part of breadcrumb construction HPE-16185
    // derived: {
    //     filterTrail: {
    //         deps: ['pageLabel', 'childLabel'],
    //         fn: function() {
    //             var label = this.pageLabel;
    //             if (this.childLabel) {
    //                 label = (this.pageLabel !== '') ? label + ' : ' + this.childLabel : this.childLabel;
    //             }
    //             return label;
    //         }
    //     }
    // }
});

module.exports = BreadcrumbModel;
